import Vue from 'vue'
import Inici from '@/pages/Inici'
import Consumibles from '@/pages/Consumibles'
import Ecoproductes from '@/pages/Ecoproductes'
import Maquinaria from '@/pages/Maquinaria'
import Contacto from '@/pages/Contacto'
import ConsumiblesChild from '@/components/consumibles/ConsumiblesChild'
import MaquinariaChild from '@/components/maquinaria/MaquinariaChild'
import EcoproductesChild from '@/components/eco-productes/EcoproductesChild'
import Router  from 'vue-router'
import VueMeta from 'vue-meta'
import i18n from './i18n'
/* import VueI18n from 'vue-i18n' */
/*import axios from 'axios' */

/* Vue.use(VueI18n) */
Vue.use(Router)
Vue.use(VueMeta)


/* const loadedLanguages = ['ca'] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }
  console.log('loadLanguageAsync')
  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet

} */

export function beforeEach(to, from, next) {

  let language = to.params.lang;
  if(!language) {
    language = 'ca'
  }
  i18n.locale = language
  next()

}

 /*        {
          path: '/',
          name: `/${i18n.locale}`+'/Inici',
          component: Inici
        }, */

export default new Router({
  
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect:  `/${i18n.locale}`,
      component: Inici,
    },
    {
      path: '/:lang',
      component: {
        render (c) { return c('router-view') }
      },
      name: '/',
      children: [
          {
            path: `/`,
            name: '/',
            component: Inici,
            meta: {
                title: 'Packet Zaragoza - Distribuidor de material d´embalatge',
                metaTags: [
                  {
                    name: 'description',
                    content: 'Packet Zaragoza.'
                  },
                  {
                    property: 'og:description',
                    content: 'Packet Zaragoza.'
                  }
                ] 
            }
          },
          {
            path: '/ca/packetgrup',
            name: '/packetgrup',
            component: Inici,
            props: true
          },
          {
            path: '/es/packetgrup',
            name: '/packetgrup',
            component: Inici,
            props: true
          },
          {
            path: `/${i18n.locale}`+'/consumibles',
            name: 'Consumibles',
            component: Consumibles,
            props: true,
            children: [
              {
                path: '/ca/consumibles/film-estirable-automatic',
                name: '/consumibles/film-estirable-automatic',
                component: ConsumiblesChild,
                metaInfo: {
                  title: 'Packet Grup - Consumibles d´embalatge Film estirable automàtic',
                  description: 'Packet Grup - Consumibles d´embalatge Film estirable automàtic',
                  metaTags: [
                    {
                      name: 'Consumibles',
                      content: 'Packet Grup Consumibles'
                    },
                    {
                      property: 'og:description',
                      content: 'Packet Grup.'
                    }
                  ] 
                },
                props: {
                  name: 'Film estirable automàtic',
                  text: 'Film estirable automàtic, preestirat o microperforat en transparent, negre, blanc o blau. Disposem de totes les qualitats i micratges del mercat.',
                  image: [
                    {
                      src:'film-estirable-automatic.jpg'
                    },
                  ],
                }
              /*
                  meta: {
                  title: 'Films estirables',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Films estirables Packet Grup.'
                    },
                    {
                      property: 'og:description',
                      content: 'Films estirables Packet Grup'
                    }
                  ]
                }
              */
              },
              {
                path: '/es/consumibles/film-estirable-automatic',
                name: '/consumibles/film-estirable-automatic',
                component: ConsumiblesChild,
                eta: {
                  title: 'Packet Grup - Consumibles de embalaje. Film estirable automático',
                  metaTags: [
                    {
                      name: 'Consumibles',
                      content: 'Packet Grup Consumibles'
                    },
                    {
                      property: 'og:description',
                      content: 'Packet Grup.'
                    }
                  ] 
                },
                props: {
                  name: 'Film estirable automático',
                  text: 'Film estirable automático, preestirado o microperforado en transparente, negro, blanco o azul. Disponemos de todas las calidades y micrajes del mercado.',
                  image: [
                    {
                      src:'film-estirable-automatic.jpg'
                    },
                  ],
                }
              },
//

              {
                path: '/ca/consumibles/film-estirable-manual',
                name: '/consumibles/film-estirable-manual',
                component: ConsumiblesChild,
                props: {
                  name: 'Film estirable manual',
                  text: 'Film estirable manual, preestirat o microperforat en transparent, negre, blanc o blau. <br>Disposem de totes les qualitats i micratges del mercat.',
                  image: [
                    {
                      src:'film-estirable.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/film-estirable-manual',
                name: '/consumibles/film-estirable-manual',
                component: ConsumiblesChild,
                props: {
                  name: 'Film estirable manual',
                  text: 'Film estirable manual, preestirado o microperforado en transparente, negro, blanco o azul. <br>Disponemos de todas las calidades y micrajes del mercado.',
                  image: [
                    {
                      src:'film-estirable.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/films-preestirats',
                name: '/consumibles/films-preestirats',
                component: ConsumiblesChild,
                props: {
                  name: 'Films pre-estirat',
                  text: 'Film estirable amb preestirat o microperforat per màquina automàtica i aplicació manual, en transparent, negre o blanc. <br> Disposem de totes les qualitats i micratges del mercat.',
                  image: [
                    {
                      src:'film-preestirat-packetgrup.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/films-preestirats',
                name: '/consumibles/films-preestirats',
                component: ConsumiblesChild,
                props: {
                  name: 'Films pre-estirat',
                  text: 'Film estirable con preestirado o micro-perforado para máquina automática y aplicación manual, en transparente, negro o blanco. <br> Disponemos de todas las calidades y micrajes del mercado.',
                  image: [
                    {
                      src:'film-preestirat-packetgrup.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/lamina-polietile-PE',
                name: '/consumibles/lamina-polietile-PE',
                component: ConsumiblesChild,
                props: {
                  name: 'Làmina polietilè PE',
                  text: 'Làmina, tub i semitub, de polietilè (PE) en diferents mides i formats. <br> Transparent i diferents colors. Possibilitat de frabicació amb VCI, anti-UVA, o qualsevol aditiu. També amb material verge o reciclat.',
                  image: [
                    {
                      src:'lamina-packetgrup.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/lamina-polietile-PE',
                name: '/consumibles/lamina-polietile-PE',
                component: ConsumiblesChild,
                props: {
                  name: 'Lámina de polietileno PE',
                  text: 'Lámina, tubo y semitubo, de polietileno (PE) en diferentes medidas y formatos. <br> Transparente y en diferentes colores. Posibilidad de fabricación con VCI, anti-UVA, o con cualquier aditivo. Tambien con materia virgen o reciclada.',
                  image: [
                    {
                      src:'lamina-packetgrup.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/cobre-palets',
                name: '/consumibles/cobre-palets',
                component: ConsumiblesChild,
                props: {
                  name: 'Cobre palet',
                  text: 'Làmina cobre-palet ideal per a la protecció. Es pot oferir troquel·lat, verge o reciclat.<br> També amb qualsevol tipus d´aditiu (VCI, anti-UVA, etc.).',
                  image: [
                    {
                      src:'cubre-palet.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/cobre-palets',
                name: '/consumibles/cobre-palets',
                component: ConsumiblesChild,
                props: {
                  name: 'Cubre palet',
                  text: 'Lámina cubre-palet ideal para la protección. Se puede ofrecer troquelado, de materia virgen o material reciclado.<br> También con cualquier tipo de aditivo (VCI, anti-UVA, etc.).',
                  image: [
                    {
                      src:'cubre-palet.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/funda-palet',
                name: '/consumibles/funda-palet',
                component: ConsumiblesChild,
                props: {
                  name: 'Funda palet',
                  text: 'Fabriquem tot tipus de funda per a palets. Màxima protecció pel teu palet, evita humitats i assegura la càrrega. <br>Possiblitat de fabricació amb materials verges o reciclats i amb tot tipus d´aditius.',
                  image: [
                    {
                      src:'funda-palet.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/funda-palet',
                name: '/consumibles/funda-palet',
                component: ConsumiblesChild,
                props: {
                  name: 'Funda palet',
                  text: 'Fabricamos todo tipo de funda para palets. Máxima protección para tu palet, evita humedades y asegura la carga. <br> Posiblidad de fabricación con materiales virgenes o materiales reciclados y con todo tipo de aditivos.',
                  image: [
                    {
                      src:'funda-palet.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/bandita',
                name: '/consumibles/bandita',
                component: ConsumiblesChild,
                props: {
                  name: 'Bandita',
                  text: 'Bobina de Film estirable transparent.<br> Mides 10cm, 12,5cm i 16,6cm.<br> Idoni per a la protecció i amb mànec de cartró per una fàcil aplicació.',
                  image: [
                    {
                      src:'bandita-packetgrup.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/bandita',
                name: '/consumibles/bandita',
                component: ConsumiblesChild,
                props: {
                  name: 'Bandita',
                  text: 'Bobina de Film estirable transparente.<br> Medidas 10cm, 12,5cm y 16,6cm. <br> Idóneo para la protección y con mango de cartón para una fácil aplicación.',
                  image: [
                    {
                      src:'bandita-packetgrup.jpg'
                    },
                  ],
                },
              },

////////////////////////////////
/////////////////2on BLOC CINTES
////////////////////////////////
              {
                path: '/ca/consumibles/cintes-adhesives',
                name: '/consumibles/cintes-adhesives',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintes adhesives',
                  text: 'Cintes adhesives de polipropilé o PVC, en totes les mides i amb diferents tipus d´adhesius, HOTMELT, ACRÍLIC o SOLVENT.',
                  image: [
                    {
                      src:'cintes-adhesives.jpg'
                    },
                    {
                      src:'cintes-adhesives-packetgrup.jpg'
                    },
                  ],
                }
              },{
                path: '/es/consumibles/cintes-adhesives',
                name: '/consumibles/cintes-adhesives',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintes adhesivas',
                  text: 'Cintes adhesives de polipropileno o PVC, en todas las medidas y con diferentes tipos de adhesivos, HOTMELT, ACRÍLICO o SOLVENTE.',
                  image: [
                    {
                      src:'cintes-adhesives.jpg'
                    },
                    {
                      src:'cintes-adhesives-packetgrup.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/consumibles/cintes-adhesives-impreses',
                name: '/consumibles/cintes-adhesives-impreses',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintes adhesives impreses personalitzades',
                  text: 'Cintes adhesives personalitzades en polipropilè i PVC.',
                  image: [
                    {
                      src:'cintes-personalitzades.jpg'
                    },
                    {
                      src:'cintes-personalitzades-2.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/consumibles/cintes-adhesives-impreses',
                name: '/consumibles/cintes-adhesives-impreses',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintes adhesivas impresas personalizadas',
                  text: 'Cintes adhesives personalizadas en poliproline y PVC.',
                  image: [
                    {
                      src:'cintes-personalitzades.jpg'
                    },
                    {
                      src:'cintes-personalitzades-2.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/consumibles/cintes-creppe',
                name: '/consumibles/cintes-creppe',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintes Creppe',
                  text: 'Cintes adhesiva de paper. Disposem de totes les mides del mercat. <br>Ideal per la protecció en pintura i mecànica.',
                  image: [
                    {
                      src:'cintes-creppe.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/cintes-creppe',
                name: '/consumibles/cintes-creppe',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintas Creppe',
                  text: 'Cintes adhesivas de papel. Disponemos de todas las medidas del mercado.<br> Ideal para la protección en pintura y mecánica.',
                  image: [
                    {
                      src:'cintes-creppe.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/cintes-tramades',
                name: '/consumibles/cintes-tramades',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintes tramades',
                  text: 'Cintes adhesives d´alta resistència amb filaments tramats per al tancament de caixes molt pesades o bé subjecció dels palets.',
                  image: [
                    {
                      src:'cintes-tramades.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/cintes-tramades',
                name: '/consumibles/cintes-tramades',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintes tramadas',
                  text: 'Cintes adhesivas de alta resistencia con filamentos tramados para el cerramiento de cajas muy pesadas o bien para las sujeción de palets.',
                  image: [
                    {
                      src:'cintes-tramades.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/precintes-seguretat',
                name: '/consumibles/precintes-seguretat',
                component: ConsumiblesChild,
                props: {
                  name: 'Precintes de seguretat',
                  text: 'Precintes de seguretat per a la seguretat i inviolabilitat dels teus enviaments.',
                  image: [
                    {
                      src:'precintes-seguretat.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/precintes-seguretat',
                name: '/consumibles/precintes-seguretat',
                component: ConsumiblesChild,
                props: {
                  name: 'Precintos de seguridad',
                  text: 'Precintos de seguridad para la seguridad e inviolabilidad de tus envíos.',
                  image: [
                    {
                      src:'precintes-seguretat.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/flejes',
                name: '/consumibles/flejes',
                component: ConsumiblesChild,
                props: {
                  name: 'Fleixos',
                  text: 'Disposem de fleixos de polipropilé, polièster, tèxtil o acer en diferents mides. Possibilitat d’impressió dels fleixos en polipropilè i polièster.',
                  image: [
                    {
                      src:'flejes-packetgrup.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/flejes',
                name: '/consumibles/flejes',
                component: ConsumiblesChild,
                props: {
                  name: 'Flejes',
                  text: 'Disponemos de flejes de polipropileno, poliéster, téxtil o acero en diferentes medidas.',
                  image: [
                    {
                      src:'flejes-packetgrup.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/cintes-ribbon',
                name: '/consumibles/cintes-ribbon',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintes Ribbon',
                  text: 'Cinta transfer per impressió d´etiquetes. <br> Disposem de totes les mides i qualitats per a tot tipus d´impresores.',
                  image: [
                    {
                      src:'cintes-ribbon.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/consumibles/cintes-ribbon',
                name: '/consumibles/cintes-ribbon',
                component: ConsumiblesChild,
                props: {
                  name: 'Cintas Ribbon',
                  text: 'Cinta transfer para impresión de etiquetas. <br> Disponemos de todas las medidas y calidades, adecuadas para todo tipo de impresoras.',
                  image: [
                    {
                      src:'cintes-ribbon.jpg'
                    },
                  ],
                }
              },

//////////////////////////////////
            // SUBMENU PRECINTES TITOL FAMILIA 3
            ///////////////////////////////////////////////////

              {
                path: '/ca/consumibles/bosses-aire',
                name: '/consumibles/bosses-aire',
                component: ConsumiblesChild,
                props: {
                  name: 'Bosses d´aire',
                  text: 'Bosses d´aire per al farciment i protecció dels vostres enviaments.<br> Disposem de totes les mides en materials verges i reciclats.',
                  image: [
                    {
                      src:'bosses-aire.jpg'
                    },                    
                    {
                      src:'enfardadores-02.jpg'
                    }
                  ],
                }    
              },
              {
                path: '/es/consumibles/bosses-aire',
                name: '/consumibles/bosses-aire',
                component: ConsumiblesChild,
                props: {
                  name: 'Bolsas de aire',
                  text: 'Bolsas de aire para el relleno y protección de tus envíos. <br> Disponemos de una gran variedad de medidas en materia virgen y materiales reciclados.',
                  image: [
                    {
                      src:'bosses-aire.jpg'
                    },                    
                    {
                      src:'enfardadores-02.jpg'
                    }
                  ],
                }    
              },
//
              {
                path: '/ca/consumibles/cartro-ondulat',
                name: '/consumibles/cartro-ondulat',
                component: ConsumiblesChild,
                props: {
                  name: 'Cartró Ondulat',
                  text: 'Bobina de cartró ondulat de doble capa. Disposem de totes les mides.',
                  image: [
                    {
                      src:'cartro-ondulat.jpg'
                    },
                    {
                      src:'carton-ondulado.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/cartro-ondulat',
                name: '/consumibles/cartro-ondulat',
                component: ConsumiblesChild,
                props: {
                  name: 'Cartón ondulado',
                  text: 'Bobina de cartón ondulado de doble capa. Disponemos de todas las medidas.',
                  image: [
                    {
                      src:'cartro-ondulat.jpg'
                    },
                    {
                      src:'carton-ondulado.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/plastic-bombolla',
                name: '/consumibles/plastic-bombolla',
                component: ConsumiblesChild,
                props: {
                  name: 'Plàstic bombolla',
                  text: 'Làmina de bombolla ideal per a la protecció del materials. Disposem de tots el gruixos i mides. També disposem de plàstic bombolla reforçada amb film, paper kraf, foam o cartró.',
                  image: [
                    {
                      src:'plastic-bombolla.jpg'
                    },
                  ],
                }    
              },
              {
                path: '/es/consumibles/plastic-bombolla',
                name: '/consumibles/plastic-bombolla',
                component: ConsumiblesChild,
                props: {
                  name: 'Plástico burbuja',
                  text: 'Lámina ideal para la protección de los materiales. Disponemos de todos los grosores y medidas. También disponemos de plástico burbuja reforzada con Film, papel Kraft, Foam o cartón.',
                  image: [
                    {
                      src:'plastic-bombolla.jpg'
                    },
                  ],
                }    
              },
//
              {
                path: '/ca/consumibles/bobines-foam',
                name: '/consumibles/bobines-foam',
                component: ConsumiblesChild,
                props: {
                  name: 'Bobines Foam (polietilè)',
                  text: 'Làmina de foam, escuma de polietilè suau. Disposem de totes les mides i gruixos.',
                  image: [
                    {
                      src:'bobines-foam-packetgrup.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/consumibles/bobines-foam',
                name: '/consumibles/bobines-foam',
                component: ConsumiblesChild,
                props: {
                  name: 'Bobinas de Foam (polietileno)',
                  text: 'Làmina de foam, espuma de polietileno suave. Disponemos de todas las medidas y grosores.',
                  image: [
                    {
                      src:'bobines-foam-packetgrup.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/consumibles/cantoneres-foam',
                name: '/consumibles/cantoneres-foam',
                component: ConsumiblesChild,
                props: {
                  name: 'Cantoneres Foam',
                  text: 'Perfil flexibles de poliestirè. Ideal per a vidres, marcs, caixes… Disposem d’una gran varietat de models, tipus, mides i gruixos.',
                  image: [
                    {
                      src:'cantoneres-FOAM.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/consumibles/cantoneres-foam',
                name: '/consumibles/cantoneres-foam',
                component: ConsumiblesChild,
                props: {
                  name: 'Cantoneras de Foam',
                  text: 'Perfil flexibles de poliestireno. Ideal para vidrios, marcos, cajas... Disponemos de una gran variedad de modelos, tipos, medidas y grosores.',
                  image: [
                    {
                      src:'cantoneres-FOAM.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/consumibles/sobres-packing-list',
                name: '/consumibles/sobres-packing-list',
                component: ConsumiblesChild,
                props: {
                  name: 'Sobres Packing list',
                  text: 'Sobres de documentació packing list. Disposem de totes les mesures i dissenys. Amb o sense finestra. Impresos o anònims.',
                  image: [
                    {
                      src:'sobres-packet-list.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/sobres-packing-list',
                name: '/consumibles/sobres-packing-list',
                component: ConsumiblesChild,
                props: {
                  name: 'Sobres packing list',
                  text: 'Sobres de documentación packing list. Disponemos de todas las medidas y diseños. Con o sin ventana. Impresos o anónimos.',
                  image: [
                    {
                      src:'sobres-packet-list.jpg'
                    },
                  ],
                },
              },
//
              { 
                path: '/ca/consumibles/bosses-mini-grip',
                name: '/consumibles/bosses-mini-grip',
                component: ConsumiblesChild,
                props: {
                  name: 'Bosses mini-grip',
                  text: 'Bosses PE amb tancament GRIP transparents o impreses. Disposem de totes les mides.',
                  image: [
                    {
                      src:'bosses-minigrip.jpg'
                    },
                  ],
                }
              },
              { 
                path: '/es/consumibles/bosses-mini-grip',
                name: '/consumibles/bosses-mini-grip',
                component: ConsumiblesChild,
                props: {
                  name: 'Bolsas mini-grip',
                  text: 'Bolsas PE con cerramiento GRIP transparentes o impresas. Disponemos de todas las medidas.',
                  image: [
                    {
                      src:'bosses-minigrip.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/consumibles/sobres-paper-bombolla',
                name: '/consumibles/sobres-paper-bombolla',
                component: ConsumiblesChild,
                props: {
                  name: 'Sobres paper bombolla',
                  text: "Sobres de làmina de bombolla en diferents mides, ideals per a la protecció d'enviaments.",
                  image: [
                    {
                      src:'sobres-paper-bombolla.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/sobres-paper-bombolla',
                name: '/consumibles/sobres-paper-bombolla',
                component: ConsumiblesChild,
                props: {
                  name: 'Sobres de papel burbuja',
                  text: "Sobres en lámina de burbujas de diferentes medidas, ideales para la protección de envíos.",
                  image: [
                    {
                      src:'sobres-paper-bombolla.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/etiquetes-adhesives',
                name: '/consumibles/etiquetes-adhesives',
                component: ConsumiblesChild,
                props: {
                  name: 'Etiquetes adhesives',
                  text: 'Disposem de gran varietat d´etiquetes, standaritzades o personalitzades en funció de les necessitats del client.',
                  image: [
                    {
                      src:'etiquetes-adhesives.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/etiquetes-adhesives',
                name: '/consumibles/etiquetes-adhesives',
                component: ConsumiblesChild,
                props: {
                  name: 'Etiquetas adhesivas',
                  text: 'Disponemos de gran variedad de etiquetas, estandarizadas o personalizadas en función de las necesidades del cliente.',
                  image: [
                    {
                      src:'etiquetes-adhesives.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/etiquetes-adr',
                name: '/consumibles/etiquetes-adr',
                component: ConsumiblesChild,
                props: {
                  name: 'Etiquetes ADR',
                  text: 'Etiquetes homologades ADR. Disposem de totes les mides i qualitats. ',
                  image: [
                    {
                      src:'etiquetes-adr.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/etiquetes-adr',
                name: '/consumibles/etiquetes-adr',
                component: ConsumiblesChild,
                props: {
                  name: 'Etiquetas ADR',
                  text: 'Etiquetas homologadas ADR. Disponemos de todas las medidas y calidades.',
                  image: [
                    {
                      src:'etiquetes-adr.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/cantoneres-cartro',
                name: '/consumibles/cantoneres-cartro',
                component: ConsumiblesChild,
                props: {
                  name: 'Cantoneres Cartró',
                  text: 'Cantoneres rígides de cartró per a la protecció i estabilitat dels palets. <br> de totes les mides i qualitats.',
                  image: [
                    {
                      src:'cantoneres-cartro.jpg'
                    },
                  ],
                },
              },
              {
                path: '/es/consumibles/cantoneres-cartro',
                name: '/consumibles/cantoneres-cartro',
                component: ConsumiblesChild,
                props: {
                  name: 'Cantoneras de cartón',
                  text: 'Cantoneras rígidas de cartón para la protección y estabilidad de los palets. <br> Disponemos de todas las medidas y calidades.',
                  image: [
                    {
                      src:'cantoneres-cartro.jpg'
                    },
                  ],
                },
              },
//
              {
                path: '/ca/consumibles/paper-kraft',
                name: '/consumibles/paper-kraft',
                component: ConsumiblesChild,
                props: {
                  name: 'Paper KRAFT',
                  text: 'Bobines de paper KRAFT de diferents gruixos i mides. Ideal per als enviaments.',
                  image: [
                    {
                      src:'paper-kraft-packetgrup.jpg'
                    },
                    {
                      src:'paper-KRAFT.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/consumibles/paper-kraft',
                name: '/consumibles/paper-kraft',
                component: ConsumiblesChild,
                props: {
                  name: 'Papel KRAFT',
                  text: 'Bobinas de papel KRAFT de diferentes grosores y medidas. Ideal para los envíos.',
                  image: [
                    {
                      src:'paper-kraft-packetgrup.jpg'
                    },
                    {
                      src:'paper-KRAFT.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/consumibles/farciment-porex',
                name: '/consumibles/farciment-porex',
                component: ConsumiblesChild,
                props: {
                  name: 'Farciment Porex',
                  text: 'Chips d’embalatge en diferents formats. Ideal per a omplir tots els espais.',
                  image: [
                    {
                      src:'farciment-porex.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/consumibles/farciment-porex',
                name: '/consumibles/farciment-porex',
                component: ConsumiblesChild,
                props: {
                  name: 'Relleno de Porex',
                  text: 'Chips de embalaje en diferentes formatos. Ideal para rellenar todos los espacios.',
                  image: [
                    {
                      src:'farciment-porex.jpg'
                    },
                  ],
                }
              }
            ]
          },
          {
            path: '/maquinaria',
            name: '/maquinaria',
            component: Maquinaria,
            children: [
              {
                path: '/ca/maquinaria/enfardadores',
                name: '/maquinaria/enfardadores',  
                component: MaquinariaChild,
                props: {
                  name: 'Enfardadores',
                  text: 'Màquines enfardadores automàtiques per al film. <br> Disposem de maquinària de gran resistència. <br>  Possibilitat de pagament per ús i lloguer.<br>  Amb una gran varietat de complements per adaptar-nos a les necessitats del client.',
                  image: [
                    {
                      src:'enfardadora.jpg'
                    },
                    {
                      src:'enfardadora-02.jpg'
                    }
                  ],
                }
              },
              {
                path: '/es/maquinaria/enfardadores',
                name: '/maquinaria/enfardadores',
                component: MaquinariaChild,
                props: {
                  name: 'Enfardadoras',
                  text: 'Máquinas enfardadoras automáticas para el film. <br> Disponemos de maquinaria de gran resistencia. <br> Posibilidad de pago por uso y alquiler. <br> Con una gran variedad de complementos para adaptarnos a las necesidades del cliente.',
                  image: [
                    {
                      src:'enfardadora.jpg'
                    },
                    {
                      src:'enfardadora-02.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/maquinaria/precintadores',
                name: '/maquinaria/precintadores',
                component: MaquinariaChild,
                props: {
                  name: 'Precintadores',
                  text: 'Màquines per a precintar, manuals i automàtiques.<br> Disposem de diferents mides.',
                  image: [
                    {
                      src:'precintadora.jpg'
                    },
                  ],
                }          
              },
              {
                path: '/es/maquinaria/precintadores',
                name: '/maquinaria/precintadores',
                component: MaquinariaChild,
                props: {
                  name: 'Precintadoras',
                  text: 'Máquinas para precintar, manuales i automáticas. <br> Disponemos de diferentes medidas.',
                  image: [
                    {
                      src:'precintadora.jpg'
                    },
                  ],
                }          
              },
//
              {
                path: '/ca/maquinaria/flexadores',
                name: '/maquinaria/flexadores',
                component: MaquinariaChild,
                props: {
                  name: 'Flexadores manuals i automàtiques',
                  text: 'Màquines per a flexar els palets de manera àgil.',
                  image: [
                    {
                      src:'flexadora-manual.jpg'
                    },
                    {
                      src:'flexadora-02.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/maquinaria/flexadores',
                name: '/maquinaria/flexadores',
                component: MaquinariaChild,
                props: {
                  name: 'Flexadoras manuals i automáticas',
                  text: 'Máquina para flejar los palets de forma ágil.',
                  image: [
                    {
                      src:'flexadora-manual.jpg'
                    },
                    {
                      src:'flexadora-02.jpg'
                    },
                  ],
                }          
              },
//
              {
                path: '/ca/maquinaria/porta-fleixos',
                name: '/maquinaria/porta-fleixos',
                component: MaquinariaChild,
                props: {
                  name: 'Carros porta fleixos',
                  text: 'Carro porta-fleixos. Diferents mides per als diferents tipus de fleixos.',
                  image: [
                    {
                      src:'carro-portaflejes.jpg'
                    },
                  ],
                }          
              },
              {
                path: '/es/maquinaria/porta-fleixos',
                name: '/maquinaria/porta-fleixos',
                component: MaquinariaChild,
                props: {
                  name: 'Carros porta flejes',
                  text: 'Carro porta-flejes. Diferentes medidas para las per als diferents tipus de fleixos.',
                  image: [
                    {
                      src:'carro-portaflejes.jpg'
                    },
                  ],
                }          
              }
            ]
          },
          {
            path: '/eco-productes',
            name:  'Ecoproductes',
            component: Ecoproductes,
            children: [
              {
                path: '/ca/eco-productes/sobres-packing-list-paper',
                name: '/eco-productes/sobres-packing-list-paper',
                component: EcoproductesChild,
                props: {
                  name: 'Sobres paper packing list ',
                  pathname: '/eco-productes/sobres-packing-list-paper',
                  text: 'Sobres de paper ecològics per a enviament de documentació, dsposem de totes les mides',
                  image: [
                    {
                      src:'sobres-packet-list.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/eco-productes/sobres-packing-list-paper',
                name: '/eco-productes/sobres-packing-list-paper',
                component: EcoproductesChild,
                props: {
                  name: 'Sobres de papel packing list',
                  pathname: '/eco-productes/sobres-packing-list-paper',
                  text: 'Sobres de papel ecológicos para el envío de documentación con todas las medidas disponibles.',
                  image: [
                    {
                      src:'sobres-packet-list.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/eco-productes/nano-films',
                name: '/eco-productes/nano-films',
                component: EcoproductesChild,
                props: {
                  name: 'Nano films',
                  text: 'Films de nova generació, amb menys micratges i alt rendiment.',
                  image: [
                    {
                      src:'sense-imatge.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/eco-productes/nano-films',
                name: '/eco-productes/nano-films',
                component: EcoproductesChild,
                props: {
                  name: 'Nano films',
                  text: 'Films de nueva generación, con menos micrage y alto rendimiento.',
                  image: [
                    {
                      src:'sense-imatge.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/eco-productes/contaneres-foam-reciclades',
                name: '/eco-productes/contaneres-foam-reciclades',
                component: EcoproductesChild,
                props: {
                  name: 'Cantoneres FOAM reciclades',
                  text: 'Cantoneres de poliestirè reciclades amb un mínim del 50%. <br> Ideal per a la protecció, disposem de totes les mides i formes.',
                  image: [
                    {
                      src:'cantonera-foam-reciclada.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/eco-productes/contaneres-foam-reciclades',
                name: '/eco-productes/contaneres-foam-reciclades',
                component: EcoproductesChild,
                props: {
                  name: 'Cantoneras FOAM recicladas',
                  text: 'Cantoneras de poliestileno recicladas con un mínimo del 50%. <br> Ideal para la protección, disponemos de todas las medidas y formas.',
                  image: [
                    {
                      src:'cantonera-foam-reciclada.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/eco-productes/cintes-kraft',
                name: '/eco-productes/cintes-kraft',
                component: EcoproductesChild,
                props: {
                  name: 'Cintes Kraft',
                  text: 'Cintes de paper per embalar en totes les mides, respectuoses amb l´entorn i el medi ambient. <br> Possibilitat de personalitzar-les segons les necessitats del client.',
                  image: [
                    {
                      src:'cinta-adhesiva-packetgrup.jpg'
                    },
                    {
                      src:'cintes-KRAFT.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/eco-productes/cintes-kraft',
                name: '/eco-productes/cintes-kraft',
                component: EcoproductesChild,
                props: {
                  name: 'Cintas Kraft',
                  text: 'Cintas de papel para embalar en todas las medidas, respetuosas con el medio ambiente. <br> Posibilidad de personalizarlas según las necesidades del cliente.',
                  image: [
                    {
                      src:'cinta-adhesiva-packetgrup.jpg'
                    },
                    {
                      src:'cintes-KRAFT.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/eco-productes/palespan-biodegradable',
                name: '/eco-productes/palespan-biodegradable',
                component: EcoproductesChild,
                props: {
                  name: 'Palespan biodegradable',
                  text: 'Farciment per enviaments dels seus productes a base de fècules vegetals.',
                  image: [
                    {
                      src:'palespan-biodegradable.jpg'
                    },
                    {
                      src:'palespan-biodegradable-02.jpg'
                    },
                  ],
                }
              },
              {
                path: '/es/eco-productes/palespan-biodegradable',
                name: '/eco-productes/palespan-biodegradable',
                component: EcoproductesChild,
                props: {
                  name: 'Palespan biodegradable',
                  text: 'Relleno para el envío de sus productos a base de féculas vegetales.',
                  image: [
                    {
                      src:'palespan-biodegradable.jpg'
                    },
                    {
                      src:'palespan-biodegradable-02.jpg'
                    },
                  ],
                }
              },
//
              {
                path: '/ca/eco-productes/farciment-paper',
                name: '/eco-productes/farciment-paper',
                component: EcoproductesChild,
                props: {
                  name: 'Farciment de paper',
                  text: 'Farciment de paper ecològic a base de paper vegetal per els enviaments dels seus productes.',
                  image: [
                    {
                      src:'farciment-paper.jpg'
                    },
                  ],
                }          
              },
              {
                path: '/es/eco-productes/farciment-paper',
                name: '/eco-productes/farciment-paper',
                component: EcoproductesChild,
                props: {
                  name: 'Relleno de papel',
                  text: 'Relleno de papel ecológico de papel vegetal para el envío de sus productos.',
                  image: [
                    {
                      src:'farciment-paper.jpg'
                    },
                  ],
                }          
              }
//
            ]
          },
          {
            path: '/ca/contacto',
            afterEnter() {location.reload(Inici)},
            name: '/contacte',
            component: require('./pages/Contacto.vue').default,
            props: {
              key: 'compoKey',
              compoKey: 1,
            }
          },
          {
            path: '/es/contacte',
            afterEnter() {location.reload(Inici)},
            name: '/contacte',
            component: require('./pages/Contacto.vue').default,
            props: {
              key: 'compoKey',
              compoKey: 2,
            }
          },
          {
            path: `/${i18n.locale}`+'/contacte-packetgrup',
            name: 'Hiden component',
            component: Contacto,
          },
        ]
      }  
  ],

  scrollBehavior (/* to, from, savedPosition */) {
    return { x: 0, y: 0, behavior: 'smooth' }
  },

})
